import {
  ComparisonLineValueTypeEnum,
  SecondLabelLineValueTypeEnum,
} from '../generated-api';
import { formatDecimals, formatWithPreAndSuffix } from './formatting';
import { SankeyNode, SankeyRenderConfig } from './types';

export function computeOriginalLabelValue(
  node: SankeyNode,
  cfg: SankeyRenderConfig,
  highestNodeAmount: number
) {
  if (
    cfg.second_label_line_value_type === SecondLabelLineValueTypeEnum.AMOUNT
  ) {
    return `${formatWithPreAndSuffix(node.amount, cfg.numberStyle)}`;
  } else if (
    cfg.second_label_line_value_type ===
    SecondLabelLineValueTypeEnum.PERCENT_NEIGHBOR
  ) {
    // If there is a single inflow or a single outflow we can calculate the node's amount as a percent of the inflow or outflow.
    if (node.flowsOut.length === 1 || node.flowsIn.length === 1) {
      let percent_value = 0;
      if (node.flowsOut.length === 1) {
        percent_value = (node.amount / node.flowsOut[0].target.amount) * 100;
      } else {
        percent_value = (node.amount / node.flowsIn[0].source.amount) * 100;
      }
      return percent_value.toFixed(0) + '%';
    } else {
      // Multiple in and out flows: Use normal (non-percentage) formatting for this node.
      return `${formatWithPreAndSuffix(node.amount, cfg.numberStyle)}`;
    }
  } else if (
    cfg.second_label_line_value_type ===
    SecondLabelLineValueTypeEnum.PERCENT_HIGHEST
  ) {
    if (node.amount >= highestNodeAmount) {
      return `${formatWithPreAndSuffix(node.amount, cfg.numberStyle)}`;
    } else {
      const percent_value = (node.amount / highestNodeAmount) * 100;
      return percent_value.toFixed(0) + '%';
    }
  }
  return '';
}
export function computeLabelValue(
  node: SankeyNode,
  cfg: SankeyRenderConfig,
  highestNodeAmount: number
) {
  if (node.use_custom_amount_label) {
    return node.custom_amount_label.trim();
  } else {
    return computeOriginalLabelValue(node, cfg, highestNodeAmount);
  }
}

export function computeOriginalComparisonLine(
  node: SankeyNode,
  cfg: SankeyRenderConfig
) {
  if (node.amountComparison) {
    if (
      cfg.comparison_line_value_type === ComparisonLineValueTypeEnum.PERCENT
    ) {
      return (
        cfg.comparison_line_prefix +
        ((node.amount / node.amountComparison - 1) * 100).toFixed(0) +
        '% ' +
        cfg.comparison_line_suffix
      );
    } else if (
      cfg.comparison_line_value_type === ComparisonLineValueTypeEnum.ABSOLUTE
    ) {
      const plus_sign_or_empty =
        node.amount - node.amountComparison > 0 ? '+' : '';
      return (
        cfg.comparison_line_prefix +
        plus_sign_or_empty +
        formatDecimals(node.amount - node.amountComparison, cfg.numberStyle) +
        cfg.comparison_line_suffix
      );
    }
  }
  return '';
}

export function computeComparisonLine(
  node: SankeyNode,
  cfg: SankeyRenderConfig
) {
  if (node.use_custom_comparison_label) {
    return node.custom_comparison_label.trim();
  } else {
    return computeOriginalComparisonLine(node, cfg);
  }
}
